import React, { useState, useEffect } from 'react';
import { getLocalStorageItem, LocalStorageKeys, setLocalStorageItem } from "@/utils/localStorageUtils";
import styles from './InfoBanner.module.css';
import IconClose from '../icons/IconClose';
import IconCaution from '../icons/IconCaution';
import IconInfo from '../icons/IconInfo';
import IconCheckCircle from '../icons/IconCheckCircle';

type InfoBannerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  message: React.ReactNode,
  storageKey?: string,
  type?: "info" | "notice" | "positive"
};

const InfoBanner = ({ 
  message,
  storageKey,
  type = "info",
  className,
  ...rest
}: InfoBannerProps) => {
  const isDismissed = () => storageKey ? getLocalStorageItem<boolean>(storageKey, false) : false;
  const [isVisible, setIsVisible] = useState(() => !isDismissed());
  
  useEffect(() => setIsVisible(!isDismissed()), [storageKey]);
  
  const handleDismiss = () => {
    if (storageKey) setLocalStorageItem<boolean>(storageKey, true);
    setIsVisible(false);
  };
  
  if (!isVisible) return null;
  
  return (
    <div
      className={`${styles.bannerContainer} ${styles[type]} ${className || ""}`}
      {...rest}
    >
      <div className={styles.leftContent}>
        {type === "notice" && <IconCaution />}
        {type === "info" && <IconInfo />}
        {type === "positive" && <IconCheckCircle size={26} />}
        <span className={styles.message}>{message}</span>
      </div>
      <button 
        className={styles.dismissButton}
        onClick={handleDismiss}
      >
        <IconClose size={24}/>
      </button>
    </div>
  );
};

export default InfoBanner;